import React from 'react';

import Content from './content';

const ContentWrap = ({ data }) => {
  const { content } = data;
  return (
    <>
      {content.children.map((child, index) => (
        <Content child={child} index={index} key={child.Key} />
      ))}
    </>
  );
};

export default ContentWrap;
